module.exports = __webpack_public_path__ + "static/media/about.a773c375.png";